module.exports = function(popularposts) {
	'use strict'
	popularposts.directive('popularPostsDir',popularPostsDir);
	popularPostsDir.$inject=[];
	function popularPostsDir() {
		return {
			template: require('./partial/popularposts.html'),
			controller:'popularpostsController',
			controllerAs:'vmpp',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/popularpostsModule/popularposts/js/directive/popularpostsDirective.js
// module id = 546
// module chunks = 0